module.exports = __webpack_public_path__ + "static/media/vinil.f569d5ef.jpg";